import React, { useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { ClockClockwiseIcon, ExamIcon } from "@phosphor-icons/react";

import CustomButton from "../../../common/general/CustomButton/CustomButton";
import AttemptHistory from "./AttemptHistory";
import StudentNavigationPanel from "./StudentNavigationPanel";
import SubmissionGrading from "./SubmissionGrading";
import { GradingCenterModalState } from "../types";

interface AssessmentGradingPanelProps {
  setModalState: (state: GradingCenterModalState) => void;
}

const AssessmentGradingPanel: React.FC<AssessmentGradingPanelProps> = ({ setModalState }) => {
  const [activeTab, setActiveTab] = useState("submission");
  const submissionTabIcon = <ExamIcon size={14} color={activeTab === "submission" ? "#3E68FE" : "#475467"} />;
  const historyTabIcon = <ClockClockwiseIcon size={14} color={activeTab === "history" ? "#3E68FE" : "#475467"} />;

  return (
    <ScrollView style={styles.content} showsVerticalScrollIndicator={false} tabIndex={0}>
      <StudentNavigationPanel setModalState={setModalState} />
      {/* Assessment Tabs */}
      <View style={styles.assessmentTabs}>
        <CustomButton
          text="Submission & Grading"
          leftIcon={submissionTabIcon}
          rightIcon={null}
          weight="normal"
          styleType={activeTab === "submission" ? "primaryTransparent" : "transparent"}
          onPress={() => setActiveTab("submission")}
          style={[styles.assessmentTab, activeTab === "submission" && styles.activeTab]}
          textStyle={[styles.assessmentTabText, activeTab === "submission" && styles.activeTabText]}
        />
        <CustomButton
          text="Attempt History"
          leftIcon={historyTabIcon}
          rightIcon={null}
          weight="normal"
          styleType={activeTab === "history" ? "primaryTransparent" : "transparent"}
          onPress={() => setActiveTab("history")}
          style={[styles.assessmentTab, activeTab === "history" && styles.activeTab]}
          textStyle={[styles.assessmentTabText, activeTab === "history" && styles.activeTabText]}
        />
      </View>

      {/* Assessment Content */}
      <View style={styles.assessmentContent}>
        {/* Submission & Grading Tab */}
        {activeTab === "submission" && <SubmissionGrading />}

        {/* Attempt History Tab */}
        {activeTab === "history" && (
          <View style={styles.assessmentTabContent}>
            <AttemptHistory />
          </View>
        )}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
  assessmentTabs: {
    flexDirection: "row",
    backgroundColor: "#F9FAFB",
    borderBottomWidth: 1,
    borderBottomColor: "#EAECF0",
  },
  assessmentTab: {
    height: 50,
    paddingHorizontal: 24,
    paddingVertical: 16,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FCFCFD",
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
    borderRadius: 0,
  },
  assessmentTabText: {
    fontSize: 14,
    color: "#475467",
  },
  activeTab: {
    borderBottomColor: "#3E68FE",
    backgroundColor: "#FCFCFD",
    color: "#2952FE",
  },
  activeTabText: {
    color: "#2952FE",
  },
  assessmentContent: {
    flex: 1,
    padding: 24,
  },
  assessmentTabContent: {
    display: "flex",
  },
});

export default AssessmentGradingPanel;
